/**
 * Whether this document is the Office add-in (KAN-1766).
 *
 * Outlook loads the task pane from `/office/…` on our own domain and frames it
 * on its own site, where our session cookie is third-party and never arrives.
 * The pane therefore signs in like the native app does, with a handoff code
 * from its login dialog, and sends the session as a Bearer token
 * (`usesBearerSession` in `lib/native/bearer-session.ts`).
 *
 * Decided once per document, from the path it was opened at, and kept as an
 * attribute on `<html>` (like `data-native-shell`): the answer has to be ready
 * before the first request goes out, and it must not change if the SPA moves
 * to another path inside the pane.
 */

/** Every page of the add-in lives under this path: the pane and its login callback. */
export const OFFICE_PATH_PREFIX = '/office/';

/** Mark the document as the Office add-in when it was opened under `/office/`. Call before mount. */
export function markOfficePane(): void {
  if (typeof window === 'undefined') return;
  if (window.location.pathname.startsWith(OFFICE_PATH_PREFIX)) {
    document.documentElement.dataset.officePane = 'true';
  }
}

/** True inside the Office add-in (task pane or its login dialog). */
export function isOfficePane(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.dataset.officePane === 'true';
}
